module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes--2-61ee78fc.png";